<template>
  <v-dialog v-model="dialog" max-width="520" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="$vuetify.breakpoint.mdAndUp"
        depressed
        color="accent"
        class="rounded-lg"
        v-on="on"
        v-bind="attrs"
        >
        + Nuevo enlace
      </v-btn>
    </template>

    <v-card class="scd rounded-lg">
      <!-- header -->
      <div class="scd__head">
        <div class="scd__head-text">
          <h2 class="scd__title">Nuevo enlace</h2>
          <p class="scd__sub">Se mostrará en tu página pública de Sartor.</p>
        </div>
        <button type="button" class="scd__close" @click="dialog = false" aria-label="Cerrar">
          <hero-icon :icon="XMarkIcon" :size="18" />
        </button>
      </div>

      <div class="scd__divider"></div>

      <!-- body -->
      <div class="scd__body">
        <v-form
          v-model="valid"
          ref="form"
          lazy-validation
          @submit.prevent="createSocial"
          >
          <v-text-field
            label="Título"
            v-model="attributes.name"
            :rules="required"
            outlined
            dense
            class="scd__field"
          ></v-text-field>

          <v-text-field
            label="Descripción corta"
            v-model="attributes.description"
            outlined
            dense
            class="scd__field"
          ></v-text-field>

          <v-text-field
            label="URL"
            v-model="attributes.link"
            :rules="required"
            outlined
            dense
            class="scd__field"
          ></v-text-field>

          <v-text-field
            label="Texto del botón"
            v-model="attributes.buttonTag"
            outlined
            dense
            class="scd__field"
          ></v-text-field>

          <v-file-input
            label="Imagen"
            v-model="attributes.image"
            outlined
            dense
            prepend-icon=""
            prepend-inner-icon="mdi-image-outline"
            class="scd__field"
          ></v-file-input>

          <!-- footer -->
          <div class="scd__actions">
            <v-btn text color="primary" class="rounded-lg" @click="dialog = false">
              Cancelar
            </v-btn>
            <v-btn color="accent" depressed class="rounded-lg" @click="createSocial">
              Crear
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { CreateSocial } from '@/graphql/mutations/social'
import HeroIcon from '@/components/shared/HeroIcon'
import XMarkIcon from 'heroicons/24/outline/x-mark.svg'

export default {
  components: { HeroIcon },

  data: () => ({
    XMarkIcon,
    valid: true,
    dialog: false,
    required: [v => !!v || 'Campo obligatorio'],
    attributes: {
      name: '',
      description: '',
      link: '',
      buttonTag: '',
      image: null
    }
  }),

  methods: {
    open () {
      this.dialog = true
    },

    createSocial () {
      this.valid = this.$refs.form.validate()

      if (this.valid) {
        this.$apollo.mutate({
          mutation: CreateSocial,
          variables: {
            input: {
              attributes: this.attributes
            }
          }
        }).then( res => {
          this.$refs.form.reset()
          this.$emit('reload')
          this.dialog = false
        })
      }
    }
  }
}
</script>

<style scoped>
.scd {
  background: #fff;
  border: 1px solid #ece7de;
}

/* header */
.scd__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 16px;
}
.scd__title {
  font-size: 19px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
  line-height: 1.2;
}
.scd__sub {
  font-size: 13px;
  color: #756f64;
  margin: 5px 0 0;
}
.scd__close {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #a39a8c;
  transition: background 0.15s ease, color 0.15s ease;
}
.scd__close:hover {
  background: #f1ece3;
  color: #1a1814;
}

.scd__divider {
  height: 1px;
  background: #ece7de;
}

/* body */
.scd__body {
  padding: 20px 24px 22px;
}
.scd__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
}

/* rounded outlined fieldsets */
.scd__field >>> fieldset {
  border-radius: 10px;
}
</style>
